export interface IForm {
	form: object;
}
